'use client'
import { useState } from 'react';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import localFont from 'next/font/local';

const fontMaque = localFont({ src: './ziqumaqueti.woff' });

export default function Header() {
  const [showPopper, setShowPopper] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const pathname = usePathname();

  const isActive = (path: string) => pathname === path;
  const isMoreToolsActive = pathname.includes('/tools') && 
    !pathname.includes('/tools/text-to-audio') && 
    !pathname.includes('/tools/extract-voice');

  return (
    <header className="relative z-30 py-4 max-w-screen-lg xl:max-w-screen-xl mx-auto flex justify-between items-center">
      <div className="logo flex align-center h-14">
        <a href="/" className="block mr-3">
          <img
            alt=""
            className="w-auto h-full"
            src="/explore/images/ai-logo.png"
            width={56}
            height={56}
          />
        </a>
        <div className="slogan flex items-center">
          <span className={`${fontMaque.className} text-2xl text-white`}>
            "音"为智能，所以简单
          </span>
        </div>
      </div>

      {/* 汉堡菜单图标 */}
      <button 
        className="md:hidden text-white"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* PC端菜单 */}
      <nav className="hidden md:flex items-center space-x-6 sm:space-x-6 ml-6 sm:ml-4">
        <div className={`nav-item ${isActive("/") ? "active" : ""}`}>
          <a
            href="/"
            className="nav-link text-white text-base flex items-center"
          >
            首页
          </a>
        </div>

        <div
          className={`nav-item ${isActive("/tools/extract-voice") ? "active" : ""}`}
        >
          <a
            href="/tools/extract-voice"
            className="nav-link text-white text-base flex items-center"
          >
            提取人声
          </a>
        </div>

        <div
          className={`nav-item ${isActive("/tools/extract-music") ? "active" : ""}`}
        >
          <a
            href="/tools/extract-music"
            className="nav-link text-white text-base flex items-center"
          >
            提取伴奏
          </a>
        </div>

        <div
          className={`nav-item ${isActive("/tools/extract-text") ? "active" : ""}`}
        >
          <a
            href="/tools/extract-text"
            className="nav-link text-white text-base flex items-center"
          >
            文案提取
          </a>
        </div>

        <div
          className={`nav-item ${isActive("/tools/text-to-audio") ? "active" : ""}`}
        >
          <a
            href="/tools/text-to-audio"
            className="nav-link text-white text-base flex items-center"
          >
            文本转语音
          </a>
        </div>

        <div className={`nav-item ${isMoreToolsActive ? "active" : ""}`}>
          {/* <a className="nav-link text-white text-base flex items-center cursor-pointer" 
             onMouseEnter={() => setShowPopper(true)}
             onMouseLeave={() => setShowPopper(false)}>
            <span>更多功能</span>
            <svg className="ml-2" fill="none" height="9" viewBox="0 0 13 9" width="13">
              <path d="M12 1L6.5 7L1 1" stroke="currentColor" strokeWidth="2"></path>
            </svg>
          </a> */}

          {showPopper && (
            <div className="nav-box absolute">
              <div
                className="popper__arrow z-20"
                style={{ right: "95px" }}
              ></div>
              <div className="z-10 overflow-hidden rounded-2xl filter drop-shadow-2xl bg-white grid grid-cols-3 gap-8 bg-white py-7 divide-x divide-gray-400">
                <div className="px-10">
                  <div className="text-lg mb-2">AI工具</div>
                  <ul>
                    <li className="py-2.5">
                      <a
                        href="/tools/replace-voice"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        AI一键替"声"
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        音轨分离
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/extract-voice"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        提取人声
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/extract-music"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        提取伴奏
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/extract-text"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        文案提取
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/text-to-audio"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        文本转语音
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="px-10">
                  <div className="text-lg mb-2">视频处理</div>
                  <ul>
                    <li className="py-2.5">
                      <a
                        href="/tools/erase-voice"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        视频消除人声
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/convert-video"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        视频格式转换
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/subtitle-voice"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        字幕编辑
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a
                        href="/tools/convert-h265"
                        className="cursor-pointer text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        视频压制
                      </a>
                    </li>
                    <li className="py-2.5">
                      <a className="text-sm text-gray-400">调整大小</a>
                    </li>
                    <li className="py-2.5">
                      <a className="text-sm text-gray-400">添加水印</a>
                    </li>
                  </ul>
                </div>
                <div className="px-10">
                  <div className="text-lg mb-2">短视频工具</div>
                  <ul>
                    <li className="py-2.5">
                      <a
                        href="/short-video"
                        className="text-sm text-gray-600 hover:text-pink-600 hover:underline"
                      >
                        短视频无水印下载
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={`nav-item ${isActive("/pricing") ? "active" : ""}`}>
          <a
            href="/pricing"
            className="nav-link text-white text-base flex items-center"
          >
            价格
          </a>
        </div>
      </nav>

      {/* 移动端菜单弹出层 */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 transition-opacity duration-300">
          <div className="bg-gradient-to-b from-gray-900 to-black h-full w-full p-6 overflow-y-auto transition-transform duration-300 transform translate-x-0">
            <div className="flex justify-between items-center mb-8">
              <button 
                className="text-white"
                onClick={() => setMobileMenuOpen(false)}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <nav className="flex flex-col space-y-6">
              <a href="/" className={`text-lg ${isActive("/") ? "text-pink-500 font-bold" : "text-white"}`}>首页</a>
              <a href="/tools/extract-voice" className={`text-lg ${isActive("/tools/extract-voice") ? "text-pink-500 font-bold" : "text-white"}`}>提取人声</a>
              <a href="/tools/extract-music" className={`text-lg ${isActive("/tools/extract-music") ? "text-pink-500 font-bold" : "text-white"}`}>提取伴奏</a>
              <a href="/tools/extract-text" className={`text-lg ${isActive("/tools/extract-text") ? "text-pink-500 font-bold" : "text-white"}`}>文案提取</a>
              <a href="/tools/text-to-audio" className={`text-lg ${isActive("/tools/text-to-audio") ? "text-pink-500 font-bold" : "text-white"}`}>文本转语音</a>
              <a href="/pricing" className={`text-lg ${isActive("/pricing") ? "text-pink-500 font-bold" : "text-white"}`}>价格</a>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}